/**
 * @generated SignedSource<<8ed02cd8bf8dfb074875fa0d4defcddd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeatureFlagsPageQuery$variables = {};
export type FeatureFlagsPageQuery$data = {
  readonly adminFeatureFlags: ReadonlyArray<{
    readonly description: string;
    readonly enabled: boolean;
    readonly name: string;
    readonly slug: string;
    readonly updatedAt: any | null;
  }>;
};
export type FeatureFlagsPageQuery = {
  response: FeatureFlagsPageQuery$data;
  variables: FeatureFlagsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "HardcodedFeatureFlag",
    "kind": "LinkedField",
    "name": "adminFeatureFlags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagsPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FeatureFlagsPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "53c88dc4bc97b4071d3e57ee39244d2b",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagsPageQuery",
    "operationKind": "query",
    "text": "query FeatureFlagsPageQuery {\n  adminFeatureFlags {\n    slug\n    name\n    description\n    enabled\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "1bb5286e00122881ff833046190ef60a";

export default node;
